import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList } from '../../models/.catalog';
import { rGrupSirket } from '../../models/rGrupSirket';
import rList from '../../models/rList';

export default class GrupSirketListeleApi extends ApiBase<pList, rList<rGrupSirket>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/GrupSirketListele',
      }),
      options
    );
  }
}
